import React, { useEffect, useState } from "react";
import { Form, Input, Container, Label } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { Loading } from "./share/loading";
import Swal from "sweetalert2";
import { Lock, User2 } from 'lucide-react';
import { PiEyeClosedLight, PiEyeLight } from 'react-icons/pi';
import "./LoginComponent.css";
import "./share/Button.css";
export function LoginComponent() {
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const user = JSON.parse(localStorage.getItem("userData"));
    const navigate = useNavigate();
    useEffect(() => {
        const checkAuth = async () => {
            let res = await fetch("/api/Auth/checkIsAuth", {
                method: "POST",
                headers: { 'token': user.token },
            })
            const resJson = await res.json();
            if (resJson.authStatus) {
                navigate("/menu")
            }
        }
        checkAuth();
    }, [])


    const initialValues = {
        username: "",
        password: "",

    }
    const onSubmit = async (values) => {
        setLoading(true);
        try {

            localStorage.removeItem("userData")

            let res = await fetch("/api/Auth/requestLogin",
                {
                    method: "POST",
                    headers: { "Content-type": "application/json" },
                    body: JSON.stringify(values)
                });
            let resJson = await res.json();
            //console.log(resJson);
            if (resJson.authStatus) {
                //setCookie
                localStorage.setItem("userData", JSON.stringify(resJson))
                navigate("/menu")
            } else {
                Swal.fire({
                    icon: "error",
                    title: "เข้าสู่ระบบไม่สำเร็จ",
                    text: `${resJson.message}`,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง"
                })
            }
        } catch (e) {
            //console.log(e)
        } finally {
            setLoading(false);
        }
    }
    const validate = values => {
        let errors = {}

        if (!values.username) {
            errors.username = "กรุณากรอกบัญชีผู้ใช้"
        }
        if (!values.password) {
            errors.password = "กรุณากรอกรหัสผ่าน"
        }
        return errors
    }
    // validate โดยใช้ formik
    const formik = useFormik({
        initialValues,
        validate,
        onSubmit,
    })
    return (
        <Container className="d-flex justify-content-center align-item-center mb-5">
            {!loading ? (
                <div className="login-container">
                    <Form onSubmit={formik.handleSubmit} autoComplete="off">
                        <div className="d-flex flex-column align-items-center justify-content-center my-5">
                            <div className="modal-body login-style p-0 mb-3">
                                <Label>บัญชีผู้ใช้ : {formik.touched.username && formik.errors.username ? <span className="text-left text-danger">{formik.errors.username}</span> : null}</Label>
                                <User2 color="#0A66C2" className="img-item-key" />
                                <Input
                                    type="text"
                                    className={formik.touched.username && formik.errors.username ? "input-error input-color rounded-pill text-center py-2" : "rounded-pill text-center input-color py-2"}
                                    // placeholder="บัญชีผู้ใช้"
                                    name="username"
                                    id="username"
                                    onBlur={formik.handleBlur}
                                    value={formik.values.username}
                                    onChange={formik.handleChange}
                                />
                            </div>

                            <div className="modal-body login-style p-0 mb-3">
                                <Label>รหัสผ่าน : {formik.touched.password && formik.errors.password ? <span className="text-left text-danger">{formik.errors.password}</span> : null}</Label>
                                <Lock color="#0A66C2" className="img-item-key" />
                                <Input
                                    type={visible ? "text" : "password"}
                                    className={formik.touched.password && formik.errors.password ? "input-error input-color rounded-pill text-center py-2" : "rounded-pill text-center input-color py-2"}
                                    // placeholder="รหัสผ่าน"
                                    name="password"
                                    id="password"
                                    onBlur={formik.handleBlur}
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                />
                                {visible ? (
                                    <PiEyeLight color="#0A66C2" className='img-item-eye' onClick={() => setVisible(!visible)} />
                                ) : (
                                    <PiEyeClosedLight color="#0A66C2" className='img-item-eye' onClick={() => setVisible(!visible)} />
                                )}
                            </div>
                            <div className="d-flex justify-content-center align-items-center mt-2">
                                <Link className="px-5" to="/registeration/RegisterType" style={{ textDecoration: "none" }}>ลงทะเบียน</Link>
                                <Link className="px-5" to="/forget-password" style={{ textDecoration: "none" }}>ลืมรหัสผ่าน/เปลี่ยนรหัสผ่าน</Link>
                            </div>
                            <button type="submit" className="confirm-button mt-4" >เข้าสู่ระบบ</button>
                        </div>
                    </Form>
                </div>
            ) :
                <Loading className="pt-5" />
            }
        </Container>
    );
}
